import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { CartCheck } from "react-bootstrap-icons";
// function Popup(nameOfBeverage , qty , vol) {
function Popup(props) {
  const [show, setShow] = useState(true);
  const handleClose = () => setShow(false);
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header style={{
            textAlign:'center',
            background:'#ccffcc'
          }} onClick={handleClose} closeButton>
          <Modal.Title >
            Product Added to Cart <CartCheck size={70}/>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {props.name} was successfully added to the cart !
        </Modal.Body>

        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  );
}
export default Popup;
